// ✅ Importamos las definiciones de columnas para cada tipo de documento de compra
import { creditNoteProductColumns } from '../../../purchases/creditNote/creditNoteProductColumns';
import { debitNoteProductColumns } from '../../../purchases/debitNote/debitNoteProductColumns';
import { excludedSubjectProductColumns } from '../../../purchases/excludedSubject/excludedSubjectProductColumns';
import { importProductColumns } from '../../../purchases/importation/columns/importProductColumns';
import { standardProductColumns } from '../../../purchases/standard/columns/standardProductColumns';
import { taxCreditProductColumns } from '../../../purchases/taxcredit/taxCreditProductColumns';

/**
 * 🗂️ Mapa centralizado de columnas para productos en documentos de compras.
 *
 * Este objeto permite acceder fácilmente a las columnas necesarias
 * dependiendo del tipo de documento de compra que se esté visualizando.
 *
 * Cada entrada del mapa apunta a un arreglo de columnas (`CustomColumn<any>[]`)
 * que define cómo se renderizan las celdas en la tabla de productos.
 *
 * ✅ Ventajas:
 * - Centraliza la configuración de columnas.
 * - Evita repetir `switch` o múltiples imports en cada componente.
 * - Facilita mantener y extender nuevas columnas en el futuro.
 *
 * 🔗 Uso típico:
 * ```ts
 * import { purchaseColumnsMap } from '.../columns/purchases';
 * 
 * const columns = purchaseColumnsMap.TAX_CREDIT; // devuelve columnas para crédito fiscal
 * ```
 */
export const purchaseColumnsMap = {
  /** 📜 Columnas para documentos de tipo Crédito Fiscal */
  TAX_CREDIT: taxCreditProductColumns,

  /** 📜 Columnas para documentos de tipo Nota de Débito */
  DEBIT_NOTE: debitNoteProductColumns,

  /** 📜 Columnas para documentos de tipo Nota de Crédito */
  CREDIT_NOTE: creditNoteProductColumns,

  /** 📜 Columnas para documentos de tipo Sujeto Excluido */
  EXCLUDED_SUBJECT: excludedSubjectProductColumns,

  /** 📜 Columnas para documentos de tipo Importación */
  IMPORT: importProductColumns,

  /** 📜 Columnas estándar para compras comunes */
  STANDARD: standardProductColumns,
};
